import React from 'react';
import * as Styles from './Preview.styles';
import {
  Button, Checkbox, IconButton, SocialMediaIcons,
} from 'gatorcomponents';
import { colorSchemes, templates } from '../../LinkNaBioWizardHandler.enum';
import { IconArrow } from '../IconArrow';
import IconCamera from '../IconCamera';
import withErrorBoundary from '@/utils/errorBoundary';
import { EXPERIENCIA_ENABLE_HIDE_HG_LOGO_ON_LINK_NA_BIO } from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

const Preview = ({
  testId = 'preview',
  handleShowPreview = () => null,
  stepLocale = {},
  title = '',
  description = '',
  links = [],
  variant = colorSchemes.SIMPLE,
  templateType = templates.FUNNY,
  allowMobile = false,
  onMobile = false,
  socialMedia = [],
  branding = true,
  setStepData = () => null,
  setFieldUpdate = () => null,
  profileImage = null,
}) => {
  const enableHideHgLogo = useFeatureIsOn(EXPERIENCIA_ENABLE_HIDE_HG_LOGO_ON_LINK_NA_BIO);

  const renderSocialLinks = () => socialMedia.map(link => (
    <Styles.SocialLink
      key={link.value}
      href={link.value.includes('http') ? link.value : `https://${link.value}`}
      target="_blank"
    >
      <SocialMediaIcons icon={link.social_icon.icon.replace('-icon', '')} />
    </Styles.SocialLink>
  ));

  const renderLinks = () => links.map(link => (
    <Styles.Link
      key={link.id}
      variant={variant}
      templateType={templateType}
      href={link.link.includes('http') ? link.link : `https://${link.link}`}
      target="_blank"
    >
      {link.description}
      {templateType === templates.MINIMALIST && (
        <Styles.IconArrowWrapper>
          <IconArrow />
        </Styles.IconArrowWrapper>
      )}
    </Styles.Link>
  ));

  return (
    <Styles.Wrapper>
      {allowMobile && onMobile && (
        <Styles.IconCloseWrapper>
          <IconButton icon="IconClose" onClick={handleShowPreview} />
        </Styles.IconCloseWrapper>
      )}

      <Styles.Card data-testid={testId} variant={variant} withDots={templateType === templates.FUNNY}>
        <Styles.Header
          variant={variant}
          templateType={templateType}
        >
          {profileImage ? (
            <Styles.ProfileAvatar src={profileImage} alt="Profile" />
          ) : (
            <Styles.ProfileAvatarPlaceholder>
              <IconCamera />
            </Styles.ProfileAvatarPlaceholder>
          )}
          <Styles.Title templateType={templateType}>
            {title || stepLocale.title}
          </Styles.Title>
          <Styles.Description templateType={templateType}>
            {description || stepLocale.description}
          </Styles.Description>
          {!!socialMedia.length && (
            <Styles.SocialLinksWrapper>
              {renderSocialLinks()}
            </Styles.SocialLinksWrapper>
          )}
        </Styles.Header>
        <Styles.Links withPadding={templateType !== templates.MINIMALIST}>
          {links.length ? renderLinks()
            : (
              <Styles.LinkMessage>
                {stepLocale.linksYouAdd}
              </Styles.LinkMessage>
            )
          }
        </Styles.Links>
      </Styles.Card>

      <Styles.PreviewLabel>
        {stepLocale.preview}
      </Styles.PreviewLabel>

      {enableHideHgLogo && stepLocale && stepLocale.hideHgLogo && (
        <Styles.CheckboxLabel
          key="hideHgLogo"
          htmlFor="#hideHgLogo"
          data-testid="hide-hg-logo-label"
          onClick={() => {
            setStepData('branding', !branding);
            setFieldUpdate(true);
          }}

        >
          <Checkbox checked={!branding || false} id="hideHgLogo" />
          <Styles.Text>
            {stepLocale.hideHgLogo}
          </Styles.Text>
        </Styles.CheckboxLabel>
      )}

      {allowMobile && onMobile && (
        <Styles.ButtonWrapper>
          <Button
            label={stepLocale.closePreview}
            variant="secondary"
            onClick={handleShowPreview}
          />
        </Styles.ButtonWrapper>
      )}
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(Preview, 'Preview');
